import { httpService } from 'src/services/fetch/HttpService';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import { SIMILAR_MOVIES_URL } from 'src/utils/constants/ApiConstants';
import {
  HTTP_HEADER_KEYS,
  HTTP_METHODS
} from 'src/utils/constants/HttpMethodsConstants';
import { buildUrlWithQueryParams } from 'src/utils/UrlGenerator';

import generateRecommendedContentQueryParams from './fetchRecommendedContentsHandler';
import { RECOMMENDED_MOVIES_QUERY } from '../../GraphQL/Queries/RecommentedMoviesQuery';
import { RecommendedRail } from '../../GraphQL/Queries/types';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

export const fetchRecommendedContents = async (
  contentId: string,
  country: string,
  translation = 'en',
  region: string,
  languages: string
): Promise<RecommendedRail | any> => {
  try {
    const response: any = await graphQlRequest(
      RECOMMENDED_MOVIES_QUERY,
      generateRecommendedContentQueryParams(
        contentId,
        country,
        translation,
        region,
        languages
      ),
      GQL_QUERIES.RECOMMENDED_MOVIES_QUERY
    );
    return response?.recommended || [];
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return [];
  }
};

export const fetchSimilarContentGenre = async (
  assetSubtype: string,
  genres: string,
  languages: string,
  countryCode: string,
  displayLanguage: string,
  contentId: string
) => {
  const url = buildUrlWithQueryParams(SIMILAR_MOVIES_URL, {
    asset_subtype: assetSubtype,
    sort_by_field: 'releasedate',
    sort_order: 'desc',
    page: '1',
    limit: '24',
    genres,
    similar: 'v1',
    languages,
    country: countryCode,
    translation: displayLanguage,
    content_id: contentId
  });
  const headers = [HTTP_HEADER_KEYS.X_ACCESS_TOKEN];
  let response = [];
  try {
    response = await httpService.fetchApiData({
      url,
      type: HTTP_METHODS.GET,
      headers
    });
  } catch (error) {
    console.error('Error while fetching content genre data: ', error);
  }

  return response;
};
